import { render, staticRenderFns } from "./Studentstatistics.vue?vue&type=template&id=6e0b2da7"
import script from "./Studentstatistics.vue?vue&type=script&lang=js"
export * from "./Studentstatistics.vue?vue&type=script&lang=js"
import style0 from "./Studentstatistics.vue?vue&type=style&index=0&id=6e0b2da7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports